import { render, staticRenderFns } from "./JlzcAllHome.vue?vue&type=template&id=72991696&scoped=true"
import script from "./JlzcAllHome.vue?vue&type=script&lang=js"
export * from "./JlzcAllHome.vue?vue&type=script&lang=js"
import style0 from "./JlzcAllHome.vue?vue&type=style&index=0&id=72991696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72991696",
  null
  
)

export default component.exports